/* eslint-disable no-unused-vars */
/* eslint-disable consistent-return */
/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-unescaped-entities */
import React, { useEffect, useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { Button, Image } from 'react-bootstrap'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/effect-creative'
import { EffectCreative } from 'swiper/modules'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'
import { mobilePhone, dragging, wavenet_logo } from '../asset'
import CIIcon from './CIIcon'

function IntroWith320HCirclePreview({
  srcs,
  correspondImgs,
  resetKey,
  redirectUrl,
}) {
  const [imageUrls, setImageUrls] = useState([])
  const [correspondImageUrls, setCorrespondImageUrls] = useState([])
  const [showIntro, setShowIntro] = useState(true)
  const [showLayer1, setShowLayer1] = useState(true)
  const [showLayer2, setShowLayer2] = useState(false)
  const [activeIndex, setActiveIndex] = useState(0)
  const [hasRedirected, setHasRedirected] = useState(false)

  const swiperRef1 = useRef(null)
  const swiperRef2 = useRef(null)
  const isDraggingRef = useRef(false)

  const IntroVideo = srcs.find((s) => s.label === 'Intro video')
  const Pic = srcs
    .filter((s) => s.label?.startsWith('Pic'))
    .sort((a, b) => {
      const getNum = (label) => parseInt(label.match(/\d+$/)?.[0] || '0', 10)
      return getNum(a.label) - getNum(b.label)
    })

  useEffect(() => {
    const newUrls = Pic.map((img) =>
      img.file instanceof File || img.file instanceof Blob
        ? URL.createObjectURL(img.file)
        : img.file
    )

    setImageUrls((prevUrls) => {
      prevUrls.forEach((url) => {
        if (
          url &&
          typeof url === 'string' &&
          url.startsWith('blob:') &&
          !newUrls.includes(url)
        ) {
          // URL.revokeObjectURL(url)
        }
      })
      return newUrls
    })

    return () => {
      newUrls.forEach((url) => {
        if (url && typeof url === 'string' && url.startsWith('blob:')) {
          // URL.revokeObjectURL(url)
        }
      })
    }
  }, [srcs])

  useEffect(() => {
    if (!Array.isArray(correspondImgs)) return

    const newUrls = correspondImgs.map((img) =>
      img?.file instanceof File || img?.file instanceof Blob
        ? {
            ...img,
            preview: URL.createObjectURL(img.file),
          }
        : img
    )

    setCorrespondImageUrls((prevUrls) => {
      prevUrls.forEach((img) => {
        if (
          img?.preview &&
          typeof img.preview === 'string' &&
          img.preview.startsWith('blob:') &&
          !newUrls.find((newImg) => newImg.preview === img.preview)
        ) {
          // URL.revokeObjectURL(img.preview)
        }
      })
      return newUrls
    })

    return () => {
      newUrls.forEach((img) => {
        if (
          img?.preview &&
          typeof img.preview === 'string' &&
          img.preview.startsWith('blob:')
        ) {
          // URL.revokeObjectURL(img.preview)
        }
      })
    }
  }, [correspondImgs])

  useEffect(() => {
    if (!IntroVideo?.file) {
      setShowIntro(false)
      return
    }
    const timer = setTimeout(() => {
      setShowIntro(false)
    }, 3000)
    return () => clearTimeout(timer)
  }, [IntroVideo, resetKey])

  useEffect(() => {
    setShowIntro(true)
    setShowLayer1(true)
    setShowLayer2(false)
    setActiveIndex(0)
    setHasRedirected(false)
  }, [resetKey])

  const isVideo = (entry) => {
    if (!entry) return false

    if (typeof entry.type === 'string') {
      return entry.type.startsWith('video')
    }

    if (typeof entry.file === 'string') {
      return entry.file.endsWith('.mp4') || entry.file.startsWith('blob:')
    }

    return false
  }

  return (
    <div
      className="scroller-hide"
      style={{ maxHeight: '57.5vh', overflow: 'auto' }}
    >
      <div className="w-100 pb-1">
        <Image
          className="position-absolute"
          src={mobilePhone}
          style={{ width: '19.5rem', right: '16%', top: '6%' }}
        />
      </div>
      <div
        className="border-bottom mb-3 d-flex"
        style={{ width: '240px', height: '55px', zIndex: '0' }}
      >
        <div className="w-80 m-auto ms-auto">
          <Image src={wavenet_logo} className="w-75 ps-3" />
        </div>
        <div className="w-20 m-auto ms-auto d-flex">
          <FontAwesomeIcon icon={faBars} className="text-end" />
        </div>
      </div>
      <div className="text-title" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-ban1" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line2" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <br />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />
      <div className="text-line" />

      {/* Intro */}
      {showIntro && IntroVideo?.file && (
        <div
          className="position-absolute"
          style={{
            width: '240px',
            right: '19.1%',
            maxHeight: '360px',
            overflow: 'hidden',
            bottom: '8%',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'flex-end',
          }}
        >
          {isVideo(IntroVideo) ? (
            <video
              src={
                IntroVideo.file instanceof File ||
                IntroVideo.file instanceof Blob
                  ? URL.createObjectURL(IntroVideo.file)
                  : IntroVideo.file
              }
              autoPlay
              controls
              muted
              playsInline
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            <img
              src={
                IntroVideo.file instanceof File ||
                IntroVideo.file instanceof Blob
                  ? URL.createObjectURL(IntroVideo.file)
                  : IntroVideo.file
              }
              alt="Intro"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          )}
        </div>
      )}

      {/* Swiper 1 */}
      {!showIntro && showLayer1 && imageUrls.length > 0 && (
        <div
          style={{
            width: '240px',
            position: 'absolute',
            zIndex: 1501,
            bottom: '8%',
          }}
        >
          <Swiper
            ref={swiperRef1}
            initialSlide={activeIndex}
            onTouchStart={() => {
              isDraggingRef.current = true
            }}
            onTouchEnd={() => {
              if (isDraggingRef.current) {
                setShowLayer2(true)
                setShowLayer1(false)
                isDraggingRef.current = false
              }
            }}
            onClick={() => {
              if (!isDraggingRef.current) {
                setShowLayer2(true)
                setShowLayer1(false)
              }
            }}
            onSlideChange={(swiper) => {
              setActiveIndex(swiper.realIndex)
            }}
            effect="creative"
            grabCursor
            speed={500}
            modules={[EffectCreative]}
            loop
            className="swiper-creative"
            style={{ width: '100%' }}
            creativeEffect={{
              prev: {
                translate: ['-120%', '120%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
              },
              next: {
                translate: ['120%', '-120%', 0],
                rotate: [0, 0, 30],
                opacity: 1,
                stretch: 50,
              },
              current: {
                translate: [0, 0, 0],
                rotate: [0, -90, 0],
                opacity: 1,
              },
              previous: {
                translate: ['50%', '-50%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
                stretch: 50,
              },
            }}
          >
            {imageUrls.map((image, index) => (
              <SwiperSlide key={index}>
                <img
                  src={image}
                  alt={`Slide ${index}`}
                  style={{
                    width: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                    display: 'block',
                  }}
                />
                <CIIcon />
              </SwiperSlide>
            ))}
          </Swiper>

          <div
            style={{
              position: 'absolute',
              bottom: '8%',
              left: '10%',
              width: '35px',
              height: '35px',
              backgroundColor: 'rgba(255,255,255,0.6)',
              borderRadius: '50%',
              zIndex: 1999,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              animation: 'dragHintLeftRight 1.8s ease-in-out infinite',
            }}
          >
            <img
              src={dragging}
              alt="dragging hint"
              style={{
                width: '32px',
                height: 'auto',
                filter: 'drop-shadow(0 0 1px white)',
                pointerEvents: 'none',
              }}
            />
          </div>

          <Button
            onClick={() => {
              setShowLayer1(false)
              setShowIntro(false)
            }}
            style={{
              position: 'absolute',
              top: '6px',
              right: '6px',
              zIndex: 2000,
              borderRadius: '50%',
              background: 'rgba(0,0,0,0.5)',
              color: '#fff',
              width: '25px',
              height: '25px',
              fontSize: '12px',
              border: 'none',
              padding: '1px 0px 2px 0px',
            }}
          >
            ✕
          </Button>
        </div>
      )}

      {/* Swiper 2 */}
      {!showIntro && showLayer2 && correspondImageUrls.length > 0 && (
        <div
          className="position-absolute"
          style={{
            width: '240px',
            bottom: '8%',
            height: '470px',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'flex-end',
            zIndex: 1501,
          }}
        >
          <Swiper
            onSwiper={(swiper) => {
              swiperRef2.current = swiper
            }}
            initialSlide={activeIndex}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            effect="creative"
            grabCursor
            speed={500}
            modules={[EffectCreative]}
            loop
            className="swiper-creative"
            style={{ width: '100%' }}
            creativeEffect={{
              prev: {
                translate: ['-120%', '120%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
              },
              next: {
                translate: ['120%', '-120%', 0],
                rotate: [0, 0, 30],
                opacity: 1,
                stretch: 50,
              },
              current: {
                translate: [0, 0, 0],
                rotate: [0, -90, 0],
                opacity: 1,
              },
              previous: {
                translate: ['50%', '-50%', 0],
                rotate: [0, 0, -30],
                opacity: 1,
                stretch: 50,
              },
            }}
          >
            {correspondImageUrls.map((img, index) => (
              <SwiperSlide
                key={index}
                style={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  justifyContent: 'center',
                  height: '100%',
                  overflow: 'hidden',
                }}
              >
                <img
                  src={img.preview}
                  alt={`Layer2-${index}`}
                  style={{ width: '100%', objectFit: 'contain' }}
                />
                <CIIcon />
              </SwiperSlide>
            ))}
          </Swiper>
          <Button
            onClick={() => {
              // if (!hasRedirected && redirectUrl) {
              //   setHasRedirected(true)
              // window.open(redirectUrl, '_blank')
              // } else {
              setShowLayer2(false)
              setShowLayer1(true)
              // }
            }}
            style={{
              position: 'absolute',
              top: '4px',
              right: '4px',
              zIndex: 2100,
              background: 'rgba(0,0,0,0.5)',
              border: 'none',
              color: '#fff',
              borderRadius: '50%',
              width: '25px',
              height: '25px',
              fontSize: '12px',
              padding: '1px 0px 2px 0px',
            }}
          >
            ✕
          </Button>
        </div>
      )}
    </div>
  )
}

IntroWith320HCirclePreview.propTypes = {
  srcs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      label: PropTypes.string,
    })
  ).isRequired,
  correspondImgs: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.oneOfType([
        PropTypes.instanceOf(File),
        PropTypes.instanceOf(Blob),
      ]),
      preview: PropTypes.string,
    })
  ),
  resetKey: PropTypes.number,
  redirectUrl: PropTypes.string,
}

IntroWith320HCirclePreview.defaultProps = {
  correspondImgs: [],
  resetKey: 0,
  redirectUrl: '',
}

export default IntroWith320HCirclePreview
